import { render, staticRenderFns } from "./RepeatPassword.vue?vue&type=template&id=6356a565&scoped=true&"
import script from "./RepeatPassword.vue?vue&type=script&lang=js&"
export * from "./RepeatPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6356a565",
  null
  
)

export default component.exports